import troubleshoot from "../views/troubleshoot/index.vue";
import troubleshoot_create from "../views/troubleshoot/create.vue";
import troubleshoot_edit from "../views/troubleshoot/edit.vue";
import troubleshoot_detail from "../views/troubleshoot/detail.vue";
import troubleshoot_import from "../views/troubleshoot/import.vue";

const routes = [
  {
    path: "/troubleshoot",
    name: "troubleshoot",
    component: troubleshoot,
    meta: { authOnly: true }
  },
  {
    path: "/troubleshoot/create",
    name: "troubleshoot_create",
    component: troubleshoot_create,
    meta: { authOnly: true }
  },
  {
    path: "/troubleshoot/edit/:uuid",
    name: "troubleshoot_edit",
    component: troubleshoot_edit,
    meta: { authOnly: true }
  },
  {
    path: "/troubleshoot/detail/:uuid",
    name: "troubleshoot_detail",
    component: troubleshoot_detail,
    meta: { authOnly: true }
  },
  {
    path: "/troubleshoot/import",
    name: "troubleshoot_import",
    component: troubleshoot_import,
    meta: { authOnly: true }
  }
];

export default routes;
